const steps = [
  {
    no: "01",
    icon: "ri-inbox-archive-line",
    title: "信息采集",
    desc: "汇总公开可得的原始材料：公告原文、现场记录、平台说明与当事人公开表达，不做删改。",
  },
  {
    no: "02",
    icon: "ri-check-double-line",
    title: "交叉验证",
    desc: "对同一节点寻找至少两个独立来源。若存在分歧，如实标出，而不是选择性保留单一说法。",
  },
  {
    no: "03",
    icon: "ri-timeline-view",
    title: "时间线还原",
    desc: "把散落的片段按时间戳重新排列，理清「先发生什么、后发生什么」，避免因果倒置。",
  },
  {
    no: "04",
    icon: "ri-sticky-note-line",
    title: "观察笔记",
    desc: "只补充结构性的观察，例如回应节奏与传播路径，不替读者下判断，也不做道德审判。",
  },
];

export default function MethodSection() {
  return (
    <section className="relative overflow-hidden bg-background-950 px-4 py-16 text-background-100 md:px-8 md:py-24">
      <div className="paper-grid absolute inset-0 opacity-[0.06]" />
      <div className="relative mx-auto w-full max-w-8xl">
        <div className="max-w-2xl">
          <div className="mb-3 flex items-center gap-2 text-xs font-medium tracking-[0.28em] text-accent-400">
            <span className="h-px w-6 bg-accent-500" />
            整理方法
          </div>
          <h2 className="font-heading text-2xl font-bold text-background-50 md:text-3xl">
            一份档案是怎么被做出来的
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-background-200/80 md:text-base">
            我们不做即时的情绪表达，而是把「事情如何一步步发生」当作可以整理的对象。四个步骤，缺一不可。
          </p>
        </div>

        <ol className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {steps.map((step) => (
            <li
              key={step.no}
              className="rounded-lg border border-background-100/15 bg-background-100/5 p-5 md:p-6"
            >
              <div className="flex items-center justify-between">
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-500 text-lg text-background-950">
                  <i className={step.icon} />
                </span>
                <span className="font-heading text-2xl font-black text-background-100/20">
                  {step.no}
                </span>
              </div>
              <h3 className="mt-5 font-heading text-base font-semibold text-background-50">
                {step.title}
              </h3>
              <p className="mt-2.5 text-sm leading-relaxed text-background-200/75">{step.desc}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}